export class NodeItem {
  public name: string;
  public date: Date;
  public parent: NodeItem;
  public children: NodeItem[];
  public showChildren: boolean;
  public selected: boolean;
  public opened: boolean;
  public fileNode: boolean;
  public mimeType: string;
  public extension: string;
  public data: any;
}
